import { BaseQuery, CorporateContentInputUpdate } from 'generated/graphql';
import { mapBaseQueryFields } from './BaseQueryInputUpdateMapper';

export const mapToCorporateContentInputUpdate = (
  q: BaseQuery,
  assignee?: string
): CorporateContentInputUpdate => {
  return {
    ...mapBaseQueryFields(q, assignee),
    fileName:
      q.queryDetails?.__typename === 'CorporateContentQuery' ? q.queryDetails?.fileName : '',
    xtmProjectName:
      q.queryDetails?.__typename === 'CorporateContentQuery' ? q.queryDetails?.xtmProjectName : ''
  };
};
